import React from 'react';
import { CertainExchange as CertainExchangeIcon } from '@magalu/stereo-ui-icons';
import CommonService from '../CommonService';

const CertainExchange = ({
  service,
  onChange,
  installmentQuantity
}) => {
  const defaultOption = [{
    value: null,
    label: 'Sem garantia estendida, somente garantia do fabricante'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CommonService, {
    service: service,
    onChange: onChange,
    Icon: CertainExchangeIcon,
    defaultOption: defaultOption,
    installmentQuantity: installmentQuantity
  }));
};

process.env.NODE_ENV !== "production" ? CertainExchange.propTypes = CommonService.propTypes : void 0;
CertainExchange.defaultProps = CommonService.defaultProps;
export default CertainExchange;